function Hamburger({ toggleMenu }) {
  return (
    <div className="Hamburger" onClick={ toggleMenu }>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  )
}

export default Hamburger;
